import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { setWithExpiry, getWithExpiry } from "../../common";
import { useSelector } from "react-redux";

const UserMeta = (props) => {
  const [translation] = useTranslation("translations");
  const [cookies] = useCookies(["sustainyou_user_jwt"]);
  const [editMeta, setEditMeta] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [savedOption, setSavedOption] = useState("");
  const [loading, setLoading] = useState(false);

  const userMetaData = useSelector(
    (state) => state?.userdata.allUserData.user_meta
  );

  useEffect(() => {
    const savedMeta = getWithExpiry(`user_meta_${props?.optionkey}`);

    if (savedMeta != null) {
      setSelectedOption(savedMeta);
      setSavedOption(savedMeta);
    } else {
      if (userMetaData && userMetaData[props?.optionkey]) {
        setSelectedOption(userMetaData[props?.optionkey]);
        setSavedOption(userMetaData[props?.optionkey]);
      }
    }
  }, [userMetaData, props]);

  const handleMetaUpdate = async (metaVal, metaKey) => {
    if (!cookies.sustainyou_user_jwt) return;

    setLoading(true);

    let userRequestData = new FormData();
    userRequestData.append("token", cookies.sustainyou_user_jwt);
    userRequestData.append("meta_key", metaKey);
    userRequestData.append("meta_value", metaVal);

    const fetchUrl = `${configVars.apiUrl}sustainchange/v1/updateusermetadata/`;

    try {
      const response = await fetch(fetchUrl, {
        method: "POST",
        headers: {
          Authorization: `Basic ${configVars.auth}`,
        },
        body: userRequestData,
      });

      const updateResponse = await response.json();

      if (updateResponse) {
        if (updateResponse.success === true) {
          setWithExpiry(`user_meta_${metaKey}`, metaVal);
        }
      }
      setSavedOption(selectedOption);
      setEditMeta(false);
      setLoading(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  //console.log( selectedOption );

  return (
    <div className="user-meta-wrap">
      <div className="user-settings-row px-4 py-3 border-top border-light-gray">
        <div className="user-settings-row-inner px-2 py-1 d-flex align-items-center">
          <div className="user-settings-data flex-grow-1 pe-2">
            <span className="setting-label d-inline-block w-100 placeholder-text">
              {props?.label}
            </span>
            {!editMeta && (
              <span className="setting-value opacity-half d-inline-block w-100">
                {props?.options[savedOption]}
              </span>
            )}
          </div>
          {!editMeta && (
            <div className="user-settings-icon">
              <button
                type="button"
                className="text-white py-1 px-2 bg-secondary btn btn-link"
                onClick={() => setEditMeta(true)}
              >
                <i className="fa fa-pencil" aria-hidden="true"></i>
              </button>
            </div>
          )}
        </div>

        {editMeta && (
          <>
            <div className="meta-values-wrap my-2">
              {props?.options &&
                props?.options.map((option, index) => {
                  const optionID = option.replace(/ /g, "")?.toLowerCase();

                  return (
                    <div className="form-check form-check-inline" key={index}>
                      <input
                        className="form-check-input"
                        type="radio"
                        id={optionID}
                        value={index}
                        checked={savedOption === index}
                        name={props?.optionkey}
                        onChange={() => {
                          setSelectedOption(index);
                          setSavedOption(index);
                        }}
                      />
                      <label className="form-check-label" htmlFor={optionID}>
                        {option}
                      </label>
                    </div>
                  );
                })}
            </div>
            <div className="text-right d-inline-flex w-100">
              <button
                className="btn btn-secondary float-end mt-1 meta-btn"
                type="button"
                onClick={() =>
                  handleMetaUpdate(selectedOption, props?.optionkey)
                }
              >
                <span className="pe-2">{translation("buttons.save")}</span>
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </button>
              <button
                type="button"
                className="text-secondary float-start btn btn-link"
                onClick={() => {
                  setEditMeta(false);
                }}
              >
                {translation("buttons.cancel")}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserMeta;
